import { render, staticRenderFns } from "./ConfirmarAtendimentoModal.vue?vue&type=template&id=07f4d700&scoped=true"
import script from "./ConfirmarAtendimentoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarAtendimentoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarAtendimentoModal.vue?vue&type=style&index=0&id=07f4d700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4d700",
  null
  
)

export default component.exports